import { Box, BoxProps, CircularProgress, Collapse, Heading, Icon, IconButton, Image, Img, Link, Stack } from "@chakra-ui/react";
import { useDeepAuth } from "components/api";
import { useVVStore } from "components/store";
import { VizvCard } from "components/vizvComponents";
import { useContext, useState } from "react";
import { FaBullhorn, FaSuperpowers } from "react-icons/fa";
import { IconType } from "react-icons/lib";
import { MdArrowBack, MdArrowDropDown, MdArrowForward, MdFlag, MdGroup, MdInfo, MdLocationCity, MdLocationSearching, MdPerson, MdPersonAdd, MdSettings, MdSettingsApplications, MdSupervisorAccount } from "react-icons/md";
import { NavLink, useLocation, useNavigate } from "react-router";
import { NYIL_BTN } from "theme";
import { DeepAuthContext } from "./auth/DeepAuth";
import { MapTools } from "./map/MapTools";

type GROUP = '' | 'user' | 'admin';

export function NavMain() {
	const isMobile = useVVStore(state => state.isMobile());
	const isTools = useVVStore(state => state.isTools());
	const setLayoutPush = useVVStore(state => state.setLayoutPush);
	const nav = useNavigate();
	const auth = useDeepAuth();
	const [openGroup, setOpenGroup] = useState<GROUP>('');
	const groupClick = (g: GROUP) => {
		setOpenGroup(openGroup === g ? '' : g);
	}


	return <Box p={8} pt={2}>
		<VizvCard alignItems='flex-start' width='fit-content'>
			<Box p={2} display='flex' flexDir='row' justifyContent='space-between' alignItems='center' alignSelf='stretch' >
				<Image src='/logo/vizvedok_neg2_100.png' height='30px' />
				{(isMobile || isTools) && <IconButton icon={isMobile ? <MdArrowForward /> : <MdArrowBack />} aria-label='hide menü' size='sm' variant='ghost' onClick={() => setLayoutPush('menu')} />}
			</Box>
			<Box width='1px' overflowX='visible' whiteSpace='nowrap'>
				<Link as={NavLink} to='/welcome' onClick={() => isMobile && setLayoutPush('menu')}
					_hover={{ textDecoration: 'none' }}>
					<Heading width='fit-content'
						position='relative' left='-.3em'
						bg='primary.main' color='#000' textShadow='1px 1px 1px #fff1'
						p={2}
						fontStyle='italic' fontSize='xl'
						boxShadow='vvtitle' fontWeight='400'
						_hover={{ background: 'primary.400' }}
					>
						„A vízügy közös ügy!”
					</Heading>
				</Link>
			</Box>
			<Box>
				<Stack  px={1} pt={2} pb={4} gap={2} >
					<NavMainLink to='/welcome/kik_vagyunk' icon={MdGroup}>Kik vagyunk?</NavMainLink>
					<NavMainLink to='/welcome/mit_csinalunk' icon={FaBullhorn} >Mit csinálunk?</NavMainLink>
					<NavMainLink to='/welcome/legyel_te_is_vizvedo' icon={MdPersonAdd} >Legyél te is VízVédő!</NavMainLink>
					<NavMainLink to='/create' icon={MdFlag}>Észleltél valamit?</NavMainLink>
					<NavMainLink to='/group' icon={MdLocationCity} >Nézz körül az országban!</NavMainLink>
					<NavMainLink to='/map' icon={MdLocationSearching} >Térkép</NavMainLink>
					<MapTools ml='auto' mr='auto' onClick={() => nav('/map')} search />
					{!auth.signedUser
						? <>
							<NavMainLink aria-label="bejelentkezés" onClick={() => auth.showSignIn()}
							//leftIcon={}
							><MdPerson /> Belépek</NavMainLink>
						</>

						: <Box>
							<NavMainLink to='' onClick={() => groupClick('user')} variant='group'>
								{auth.userAny?.pictureUrl ? <Img src={auth.userAny.pictureUrl} w='25px' h='25px' borderRadius='sm' borderRight='2px solid #0006' borderBottom='1px solid #0006' /> : <Icon as={MdPerson} />}
								{auth.userAny?.userName || <CircularProgress isIndeterminate size='20px' />}
								<Box display='inline-block' ml='auto'>
									<Icon as={MdArrowDropDown} />
								</Box>
							</NavMainLink>
							<Collapse in={openGroup === 'user'} animateOpacity >
								<Stack gap={1} mt={1}>
									<NavMainLink variant="submenu" to='/profile'>Profilom</NavMainLink>
									<NavMainLink variant="submenu" to={`/profile-affairs/${auth.signedUser.userKey}`}>Bejelentéseim</NavMainLink>
									<NavMainLink variant="submenu" to='/user/account'>Fiókom</NavMainLink>
									<NavMainLink variant="submenu" onClick={auth.signOut}>Kilépek</NavMainLink>
								</Stack>
							</Collapse>
						</Box>
					}
					{auth.userConfirmed && auth.userConfirmed.isAdmin > 0 &&
						<Box>
							<NavMainLink variant='group' to='' onClick={() => groupClick('admin')} icon={MdSettings}>
								Admin
								<Box display='inline-block' ml='auto'>
									<Icon as={MdArrowDropDown} />
								</Box>
							</NavMainLink>
							<Collapse in={openGroup === 'admin'} animateOpacity >
								<Stack gap={1} mt={1}>
									<NavMainLink variant="submenu" to='/admin/logs-to-confirm'>Jóváhagyás</NavMainLink>
									<NavMainLink variant="submenu" to='/admin/affair'>Bejelentések</NavMainLink>
									<NavMainLink variant="submenu" to='/admin/user'>Felhasználók</NavMainLink>
								</Stack>
							</Collapse>
						</Box>
					}
					<NavMainLink to='/impresszum' icon={MdInfo}>Impresszum</NavMainLink>
				</Stack>

			</Box>
		</VizvCard >
	</Box >
}



export interface NavMainLinkProps extends BoxProps {
	to?: string;
	variant?: 'menu' | 'group' | 'submenu';
	icon?: IconType;
}

export function NavMainLink({ children, onClick: pOnClick, to, variant = 'menu', icon, ...rest }: NavMainLinkProps) {
	const location = useLocation();
	const isMobile = useVVStore(state => state.isMobile());
	const setLayoutPush = useVVStore(state => state.setLayoutPush);

	const onClick = (e: React.MouseEvent<any>) => {
		if (pOnClick) {
			if (!to)
				e.preventDefault();
			pOnClick(e);
		} else {
			if (isMobile)
				setLayoutPush('menu');
		}
	}

	const isActive = location.pathname === to;//.startsWith(to||'xxxy');

	return <Heading as={NavLink} to={to || ''} onClick={onClick}
		position='relative' left={0}
		display='flex' flexDir='row' alignItems='center' gap={1}
		background='#fff1'
		//color='#d2ddd9' 
		color='#fffd'


		{...isMobile ? { fontWeight: '400', fontSize: 'lg' } : { fontWeight: '400', fontSize: 'md' }}

		p={2}
		_hover={{ textDecor: 'none', /*left: '0.2em',*/ bg: '#fff2', color: '#fff' }}
		{...isActive && {
			bg: 'secondary.main', color: '#000', fontWeight: 500, left: '1em',
			_hover: { left: '1.2em' }
		}}
		transition={`background-color .15s ease-out, color .15s ease-out, left .15s ease-out`}


		{...variant === 'submenu' && {
			p: 1,
			fontSize: 'sm',
			left: '1.5em',
			mr: '2em',
			//_hover: { left: '1.7em', }
		}}

		{...rest}


	>
		{icon && <Icon as={icon}
			//{...!isActive&&{color:'secondary.400'}} 
			opacity={.6}
		/>}
		{children}
		{variant !== 'group' && <Box ml='auto' w='18px'>{isActive && <Box as='span' fontFamily='initial' >{NYIL_BTN}</Box>}</Box>}
	</Heading>
}










